/*!*
 * @author yueheqin
 * @date 2019/7/4
 * @project zujuanzaixian
 * @desc
 */
import {download} from '../utils/download'

export const downloadMixin = {
  methods: {
    download (url) {
      download(url)
    }
  }
}
